import { useStore } from 'jotai';
import { useCallback } from 'react';
import { readAccessToken } from '../state/AuthState';

/**
 * Returns a getter for the current access token. The getter keeps its identity for the whole session and
 * reads the token when it is called, so services that hold on to it (MaggieHttp, the WebSocket services)
 * always send the live token, including after it is renewed.
 */
export function useToken() {
  const store = useStore();

  return useCallback(async (): Promise<string> => readAccessToken(store), [store]);
}
